import { ActiveMeters, Simulation, IMeterTypes } from "@edp-components/edp-card-widgets/edp-widget-consumptions/edp-consumptions.models";
import { Complaint } from "@edp-pages/customer-support/modules/requests-complaints/models/complaint.model";
import { ICampaign } from "@edp-models/edp-campaigns.model";
import { IInvoice, IInvoicesChart } from "@edp-models/invoices.model";
import { IBankList } from "@edp-models/bank.model";
import { IReading } from "@edp-models/readings.model";
import { ElectricMobilityWidget } from "@edp-models/electric-mobility.model";
import { IFunciona } from "@edp-components/edp-card-widgets/edp-widget-funciona/funciona-service-type.model";

export interface IDashboardState {
    invoices: {
        data: {
            invoices: IInvoice[];
            invoicesChart: IInvoicesChart[];
            monthlyAverage: number;
        },
        lastAPIError: Error
    };
    balance: {
        data: {
            dateFrom: string,
            dateTo: string,
            balance: number,
            debtBalance: number,
            invoices?: IInvoice[],
            movements?: any[],
            invoicesChart?: IInvoicesChart[]
        },
        lastAPIError: Error
    };
    activeMetersElectricity: ActiveMeters[];
    activeMetersGas: ActiveMeters[];
    simulation: Simulation;
    contractRequest: {
        data: Complaint[];
        lastAPIError: Error;
    };
    uploadReading: IReading;
    funciona: {
        data: IFunciona;
        lastAPIError: Error;
    };
    campaigns: {
        data: ICampaign[];
        lastAPIError: Error;
    };
    recaptcha: boolean;
    recaptchaResponse: string;
    bankList: IBankList[];
    meterInstructions: {
        data: IMeterTypes;
        lastAPIError: Error;
    };
    electricMobility: {
        data: ElectricMobilityWidget;
        lastAPIError: Error;
    };
    showNewLocalToastr: boolean;
}

export const initialDashboardKeepState = {
    uploadReading: null,
    simulation: null,
    funciona: {
        data: null,
        lastAPIError: null,
    },
    campaigns: {
        data: null,
        lastAPIError: null,
    },
    meterInstructions: {
        data: null,
        lastAPIError: null,
    },
    electricMobility: {
        data: null,
        lastAPIError: null,
    },
    showNewLocalToastr: false
};

export const initialDashboardResetState = {
    invoices: {
        data: {
            invoices: null,
            invoicesChart: null,
            monthlyAverage: null,
        },
        lastAPIError: null,
    },
    balance: {
        data: {
            dateFrom: null,
            dateTo: null,
            balance: 0,
            debtBalance: 0,
        },
        lastAPIError: null,
    },
    activeMetersElectricity: null,
    activeMetersGas: null,
    contractRequest: {
        data: null,
        lastAPIError: null,
    },
    closeMenu: null,
    recaptcha: null,
    recaptchaResponse: null,
    bankList: [],
    showNewLocalToastr: false
};

export const initialDashboardState: IDashboardState = {
    ...initialDashboardKeepState,
    ...initialDashboardResetState,
};
